import React from 'react'


import { NavigationItem } from '../navigation/navigation-items'
import { HomeSubMenu, ProfileSubMenu, QuickLinks } from '../navigation/app-menu'
import { ReactFC } from '../types'
import styled from 'styled-components'
import { IconContext } from 'react-icons'
import { useTheme } from '@material-ui/core'

const MenuContainer = styled(QuickLinks)`
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.secondary.main};
    && .Mui-selected {
        background-color: ${({ theme }) => theme.palette.primary.light};
        color: ${({ theme }) => theme.palette.primary.contrastText};
    }
`

export const AppNavigationMenu: ReactFC<{ create?: React.ReactNode, className?: string }> = ({ create = null, ...props }) => {
    const theme = useTheme()
    return (
        
        <IconContext.Provider value={{ color: theme.palette.secondary.main }}>
            <MenuContainer {...props}>
                <HomeSubMenu />
                <NavigationItem place="groups" />
                <ProfileSubMenu />
                {create}
                <NavigationItem place="notifications" />
            </MenuContainer>
        </IconContext.Provider>
    )
}

export default AppNavigationMenu
